module.exports = __webpack_public_path__ + "img/14.0d6dcb28.png";